import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M6 4v16a1 1 0 0 0 1.524 .852l13 -8a1 1 0 0 0 0 -1.704l-13 -8a1 1 0 0 0 -1.524 .852z","key":"svg-0"}]]

const IconPlayerPlayFilled = createReactComponent('filled', 'player-play-filled', 'PlayerPlayFilled', __iconNode);

export default IconPlayerPlayFilled;